export function isChangedSaveToProfileValue({ item, value }) {
  return (
    (item.permissions.can_dont_save_to_profile && !value) ||
    (item.permissions.can_save_to_profile && value)
  )
}

export function isChangedSendAdditionalEmailValue({ item, value }) {
  return (
    (item.permissions.can_dont_send_additional_email && !value) ||
    (item.permissions.can_send_additional_email && value)
  )
}

export function isChangedSendEmailValue({ item, value }) {
  return (
    (item.permissions.can_dont_send_email && !value) ||
    (item.permissions.can_send_email && value)
  )
}

export function isChangedSendEpostValue({ item, value }) {
  return (
    (item.epost_permissions.can_dont_send_epost && !value) ||
    (item.epost_permissions.can_send_epost && value)
  )
}
